/*
 * Filename: template-object.model.ts
 */

 import {
    types,
    Instance,
    ModelInstanceTypeProps,
    ModelProperties,
    getSnapshot,
    applySnapshot
} from 'mobx-state-tree';

let initialState = {};

const TemplateSFObjectModel = types.model('SFObject', {
    activateable: types.boolean,
    createable: types.boolean,
    custom: types.boolean,
    customSetting: types.boolean,
    deletable: types.boolean,
    deprecatedAndHidden: types.boolean,
    feedEnabled: types.boolean,
    hasSubtypes: types.boolean,
    isSubtype: types.boolean,
    keyPrefix: types.maybe(types.string),
    label: types.string,
    labelPlural: types.string,
    layoutable: types.boolean,
    mergeable: types.boolean,
    mruEnabled: types.boolean,
    name: types.string,
    queryable: types.boolean,
    replicateable: types.boolean,
    retrieveable: types.boolean,
    searchable: types.boolean,
    triggerable: types.boolean,
    undeletable: types.boolean,
    updateable: types.boolean,
    urls: types.frozen({})
});

const TemplateLayoutModel = types.model('TemplateLayout', {
    attributes: types.model({ type: types.string, url: types.string }),
    Id: types.string,
    Name: types.string,
    TableEnumOrId: types.string
});
const QuickActionsModel = types.model('TemplateLayout', {
    attributes: types.model({ type: types.string, url: types.string }),
    DeveloperName: types.string,
    Label: types.string,
    SobjectType: types.string,
    Type: types.string,
    NamespacePrefix : types.string,
});
const ObjectFieldDetails = types.model({
    fields: types.optional(types.array(types.frozen({})), []),
    recordTypeInfos: types.optional(types.array(types.frozen({})), []),
})

export const TemplateSFObjectStoreModel = types
    .model('TemplateSFObjectStore', {
        sfObjects: types.optional(types.array(TemplateSFObjectModel),[]),
        deploedObject: types.optional(types.frozen({}),{}),
        templateLayouts: types.optional(types.array(TemplateLayoutModel),[]),
        deployedLayout: types.optional(types.frozen({}),{}),
        objectFields: types.optional(ObjectFieldDetails, {}),
        referenceObjectFields: types.optional(ObjectFieldDetails, {}),
        mainReferenceObjectFields: types.optional(ObjectFieldDetails, {}),
        standardObjectFields: types.optional(ObjectFieldDetails, {}),
        quickActions: types.optional(types.array(QuickActionsModel),[])
    }).actions((self:any) => ({
        loadSFObjects(sfObjects: ITemplateSFObject) {
            self.sfObjects = sfObjects;
        },
        loadSFObjectFields(sfObjectFields: any) {
            self.objectFields = sfObjectFields;
        },
        loadSFStandardObjectFields(sfStandardObjectFields: any) {
            self.standardObjectFields = sfStandardObjectFields;
        },
        loadReferenceObjectFields(sfReferenceObjectFields: any) {
            self.referenceObjectFields = sfReferenceObjectFields;
        },
        loadMainReferenceObjectFields(sfReferenceObjectFields: any) {
            self.mainReferenceObjectFields = sfReferenceObjectFields;
        },
        loadLayouts(layouts: ITemplateLayout) {
            self.templateLayouts = layouts;
        },
        loadQuickActions(quickActions:IQuickActions) {
            self.quickActions = quickActions;
        },
        resetLayouts() {
            self.templateLayouts = [];
        },
        loadDeployedLayout(layouts: ITemplateLayout) {
            self.templateLayouts = layouts;
        },
        resetQuickActions() {
            self.quickActions = [];
        }
    }));
   export const TemplateSFObjectStore = TemplateSFObjectStoreModel.create({
    sfObjects: [],
    deploedObject: {},
    templateLayouts: [],
    deployedLayout: {},
    });

export type ITemplateSFObjectStore = Instance<typeof TemplateSFObjectStoreModel>;
export type ITemplateSFObject = Instance<typeof TemplateSFObjectModel>;
export type ITemplateLayout = Instance<typeof TemplateLayoutModel>;
export type IQuickActions = Instance<typeof QuickActionsModel>;
